enum Page {
  Nextup = "",
  Today = "racing",
  Result = "result",
  History = "history"
}

export default Page;
